import React, { useState , useRef } from "react";
import "./Roof_waterproofing_bituminous_sheets.css";
import { Link } from "react-router-dom";
import ContactSection2 from '../Category/ContactSection2';
import Adsense from "../Adsense";       // 🔥 ייבוא באנר דף הבית (או באנר כללי)
import InArticleAd from "../InArticleAd"; // 🔥 ייבוא המודעה החדשה לגוף המאמר

export default function Cleaning_windows_and_buildings_in_abseiling() {


  return (

    <div className="Roof_waterproofing_bituminous_sheets-page">
      <div className="Roof_waterproofing_bituminous_sheets-hero">
        <div className="Roof_waterproofing_bituminous_sheets-overlay">
          <h1>     ניקיון חלונות ומבנים בסנפלינג
 </h1>
        </div>
<div>
</div>
</div>
    <div className="page6">
 <div className="breadcrumb6">
  <Link to="/">בית</Link> /{" "}
  <Link to="/OurServices"> השירותים שלנו </Link>/{" "}
   <Link to="/Cleaning_windows_and_buildings_in_abseiling">   ניקיון חלונות ומבנים בסנפלינג
   </Link>{" "}
</div>
    </div>

      {/* CONTENT */}
<div className="page6">
  <div className="container">
            <div className="red-banner">
ניקיון חלונות ומבנים בסנפלינג



</div>
    <div className="content-row2">



      <div className="text-box">

<p>

ניקיון מבנים וניקיון חלונות הוא דבר המעיד על רמת האסטטיקה ויוקרת המשרד / הבית את החלונות יש לנקות באופן שוטף למניעת הצטברות של שומנים, פיח , אבק, אבנית ועוד.





</p>
  <h2 className="info-title"> אנו באיטומים בגבהים מעמידים לרשותכם צוות איכותי ותיק ומנוסה לביצוע כל העבודות הנ"ל בעל הסמכות ואישורי עבודה מתאימים נשמח שגם אתם תהיו בין לקוחתינו.








</h2>

  


      </div>

    </div>




    <ContactSection2/>
<div className="links2">


<Link to="/Sealing_around_windows_in_a_variety_of_solutions" className="link-right" >    איטום סביב חלונות במגוון פתרונות 
</Link>
  <Link to="/Roof_waterproofing_bituminous_sheets" className="link-left" > איטום גגות - יריעות ביטומניות
 </Link>


</div>

      </div>
    </div>
  

      </div>
  );
}


